var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatherPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.129,
    height: 16.16,
    viewBox: "0 0 16.129 16.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M18.3,14.349v2.282a1.521,1.521,0,0,1-1.658,1.521,15.053,15.053,0,0,1-6.564-2.335,14.833,14.833,0,0,1-4.564-4.564A15.053,15.053,0,0,1,3.174,4.658,1.521,1.521,0,0,1,4.688,3H6.97A1.521,1.521,0,0,1,8.491,4.308a9.767,9.767,0,0,0,.532,2.137,1.521,1.521,0,0,1-.342,1.6l-.966.966a12.17,12.17,0,0,0,4.564,4.564l.966-.966a1.521,1.521,0,0,1,1.6-.342,9.767,9.767,0,0,0,2.137.532A1.521,1.521,0,0,1,18.3,14.349Z",
    transform: "translate(-2.667 -2.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherPhone);
export default __webpack_public_path__ + "static/media/feather-phone.d2cdd85ff98f2b3068588b56100daeff.svg";
export { ForwardRef as ReactComponent };